import { Asterisk } from "./Asterisk";
import React, { useContext, useLayoutEffect, useRef, useState, useMemo } from "react";
import { FormGroup, Label, Input } from "reactstrap";
import { CountrySelect } from "../modules/CountrySelect/CountrySelect";
import EventLabel, { GetEventLabelValueFn } from "./EventLabel";
import Store from "../store/Store";
import PhoneNumberField from "./PhoneNumberField";

const CustomInput = (props) => {
  const {
    onChange,
    type,
    noMargin = false,
    prefixClassName = undefined,
    staticLabel = false,
    displayType = "short",
    label,
    cssId,
    value,
    subLabel,
    disabled = false,
    noLabel = false,
    noInputField = false,
    lang,
    readonly,
    valid,
    required,
    onKeyDown,
    eventId,
    appendButton = null,
    validationError = false,
    validationErrorMessage = "",
    onBlur,
    onFocus,
    onClick,
    placeholder,
    showConfirmInput = false,
    confirmInputValue = "",
    confirmInputOnChange,
    autocomplete = null,
    settings,
    invoice = false,
  } = props;

  const store = useContext(Store);
  const inputRef = useRef(null);
  const btnWrapRef = useRef(null);
  const [btnPos, setBtnPos] = useState(0);

  const { validations } = store;

  useLayoutEffect(() => {
    if (inputRef.current && btnWrapRef.current) {
      let inputWidth = inputRef.current.getBoundingClientRect().width;
      let marginLeft = parseFloat(getComputedStyle(inputRef.current).marginLeft.replace("px", ""));
      let btnWidth = btnWrapRef.current.getBoundingClientRect().width;
      let pos = inputWidth + (marginLeft ?? 0) - btnWidth - 5;
      if (Math.abs(btnPos - pos) > 1) {
        setBtnPos(pos);
      }
    }
  });

  const ariaLabel = useMemo(() => {
    return GetEventLabelValueFn({ name: type, groupName: "Content.StaticLabels" }, store.eventLabels, store.environment, store.updateEventLabels);
  });

  const autoCompleteType = autocomplete || type;
  const inputProps = {
    type: noInputField ? "hidden" : displayType == "long" ? "textarea" : "text",
    disabled,
    readOnly: readonly,
    className: prefixClassName + `${validationError ? " validation-error" : ""}`,
    ["aria-label"]: ariaLabel,
    name: label,
    autoComplete: autoCompleteType,
    value,
    onChange,
    onKeyDown: typeof onKeyDown === "function" ? (e) => onKeyDown({ ...e }) : undefined,
    onBlur: typeof onBlur === "function" ? (e) => onBlur({ ...e }) : undefined,
    onFocus: typeof onFocus === "function" ? (e) => onFocus({ ...e }) : undefined,
    placeholder: placeholder ? placeholder : undefined,
    onClick: typeof onClick === "function" ? (e) => onClick({ ...e }) : undefined,
    settings,
  };

  return (
    <>
      <FormGroup style={{ margin: noMargin ? 0 : "inital" }} className={prefixClassName}>
        {!noLabel && !settings?.hideLabel ? (
          <div className={`title-holder ${validationError ? "validation-error" : ""}`}>
            {staticLabel ? (
              <Label className={prefixClassName} for={cssId}>
                {label && <EventLabel name={label} groupName={"Content.StaticLabels"} />}
                {required ? <Asterisk /> : null}
              </Label>
            ) : (
              <Label className={prefixClassName + " flex"} for={cssId}>
                {label}
                {required ? <Asterisk /> : null}
              </Label>
            )}
            {subLabel ? (
              <Label className="sublabel" for={cssId}>
                {subLabel}
              </Label>
            ) : null}
          </div>
        ) : null}
        {appendButton ? (
          <>
            <Input innerRef={inputRef} style={{ border: valid === false ? "1px solid #d53443" : undefined }} {...inputProps} />
            &nbsp;
            {appendButton}
          </>
        ) : type == "CountryCode" || type == "CountryId" ? (
          <CountrySelect prefixClassName={prefixClassName} onChange={onChange} value={value} type={"CountryId"} eventId={eventId} lang={lang} preselected={store?.defaultSelectedCountry || 206} />
        ) : type == "Telephone1" ? (
          <PhoneNumberField {...inputProps} valid={valid} invoice={invoice} />
        ) : (
          <Input innerRef={inputRef} style={{ border: valid === false ? "1px solid #d53443" : undefined }} {...inputProps} />
        )}
      </FormGroup>
      {showConfirmInput ? <ConfirmationInput {...inputProps} prefixClassName={prefixClassName} parentLabel={type} valid={valid} confirmInputOnChange={confirmInputOnChange} confirmInputValue={confirmInputValue} /> : null}
    </>
  );
};

const ConfirmationInput = ({ disabled, readOnly, valid, prefixClassName, parentLabel, confirmInputOnChange, confirmInputValue }) => {
  return (
    <FormGroup className={prefixClassName}>
      <div className="title-holder">
        <Label className="flex">
          <EventLabel name={"Confirm" + parentLabel} groupName={"Content.StaticLabels"} />
          <Asterisk />
        </Label>
      </div>
      <Input
        {...{
          disabled,
          readOnly,
          value: confirmInputValue,
          onChange: confirmInputOnChange,
        }}
        style={{ border: valid === false ? "1px solid #d53443" : undefined }}
      />
    </FormGroup>
  );
};
export default CustomInput;
